import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { rotaDeTela } from '@/features/permissoes/guardas';
import { buscaDosAlunos } from '@/features/usuarios/busca';
import { ListaDeMembros } from '@/features/usuarios/componentes/ListaDeMembros';

export const Route = createFileRoute('/_autenticado/alunos/')({
  ...rotaDeTela('alunos.lista'),
  validateSearch: buscaDosAlunos,
  component: Pagina,
});

function Pagina() {
  const { novo, ...filtros } = Route.useSearch();
  const navigate = Route.useNavigate();
  // O atalho do Início abre o formulário e sai da URL (recarregar não abre de novo).
  useEffect(() => {
    if (novo === true) void navigate({ search: filtros, replace: true });
  }, [novo, filtros, navigate]);
  return (
    <ListaDeMembros
      abrirConvite={novo === true}
      grupo="alunos"
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
